module.exports = __webpack_public_path__ + "media/honey-icons/icon-multi-choice-off-76a47084.svg";